class SessionDB {
  static setItem(key: string, value: string) {
    if (!key) return;
    sessionStorage.setItem(key, value);
  }

  static getItem(key: string) {
    if (!key) return;
    const item = sessionStorage.getItem(key);
    return item;
  }

  static removeItem(key: string) {
    if (!key) return;
    sessionStorage.removeItem(key);
  }

  static clear() {
    sessionStorage.clear();
  }

  static getAccessToken() {
    const token = this.getItem('access_token');
    return token || '';
  }

  static setAccessToken(token: string) {
    this.setItem('access_token', token);
  }

  static removeAccessToken() {
    this.removeItem('access_token');
  }

  // Cookie helper methods for refresh token
  static getRefreshTokenFromCookie(): string | null {
    if (typeof document === 'undefined') return null;
    
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'refreshToken') {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

  static clearRefreshTokenCookie() {
    if (typeof document === 'undefined') return;
    document.cookie = 'refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
}

export default SessionDB;
